import {
  DrawerFooterArea,
  Drawer as DrawerType,
  MelcoModelsUserSerialNumber,
} from "melco-shared-logic";
import {
  Col,
  Drawer,
  FullWidthSpace,
  Row,
  Steps,
  DesignTokens,
} from "melco-ui";
import { useState } from "react";
import { CopyLicense } from "../form/CopyLicense";
import {
  ChangeLevelLicenseForm,
  ChangeLevelLicenseFormValueType,
} from "../form/changelevel/ChangeLevelLicenseForm";
//import { ChangeLevelLicenseSummary } from "../form/changelevel/ChangeLevelLicenseSummary";
//import { ChangeLevelLicenseVersionAndLevel } from "../form/changelevel/ChangeLevelLicenseVersionAndLevel";
import { useTranslation } from "react-i18next";
import { ChangeLevelLicenseLevel } from "../form/changelevel/ChangeLevelLicenseLevel";
import { ChangeLevelLicenseSummary } from "../form/changelevel/ChangeLevelLicenseSummary";

const { spacings } = DesignTokens;

type ChangeLevelLicenseDrawerProps = {
  drawer: DrawerType;
};

export type NewSelectedValuesForLicenseChangeLevel = {
  //  new_version_id:string;
  new_subscription_code: string;
  //new_version_id_display_value: string;
  new_subscription_code_display_value: string;
  subscription_start_date?: Date | null;
};

export const ChangeLevelLicenseDrawer: React.FC<
  ChangeLevelLicenseDrawerProps
> = ({ drawer }) => {
  const { closeDrawer, isDrawerOpen } = drawer;
  const [currentStep, setCurrentStep] = useState(0);
  const [licenseFormValues, setLicenseFormValues] =
    useState<ChangeLevelLicenseFormValueType>();
  const [changelevelLicenseResponse, setChangeLevelLicenseResponse] = useState<
    MelcoModelsUserSerialNumber | undefined
  >();
  const [currentLicense, setCurrentLicense] = useState<
    MelcoModelsUserSerialNumber | undefined
  >();
  const [newValuesToChangeLevel, setNewValuesToChangeLevel] =
    useState<NewSelectedValuesForLicenseChangeLevel>();

  const { t } = useTranslation();

  const onCloseDrawer = () => {
    setCurrentStep(0);
    setLicenseFormValues({

      serial_number: "",
      language: "",
      melco_customer_id: ""
    })
    closeDrawer();
  };

  const onChangeLevelLicenseStep1CallBackFn = (
    values: ChangeLevelLicenseFormValueType,
    currentLicense: MelcoModelsUserSerialNumber | undefined
  ) => {
    setLicenseFormValues(values);
    setCurrentStep(currentStep + 1);
    setCurrentLicense(currentLicense);
  };

  const onChangeLevelLicenseStep2CallBackFn = (
    newValuesToChangeLevel: NewSelectedValuesForLicenseChangeLevel,
    currentLicense?: MelcoModelsUserSerialNumber | undefined
  ) => {
    setCurrentStep(currentStep + 1);

    setNewValuesToChangeLevel(newValuesToChangeLevel);
    setCurrentLicense(currentLicense);
  };

  const onChangeLevelLicenseStep3CallBackFn = (
    obj: MelcoModelsUserSerialNumber | undefined
  ) => {
    setChangeLevelLicenseResponse(obj);
    setCurrentStep(currentStep + 1);
  };

  const stepback = () => {
    setCurrentStep(currentStep - 1);
  };

  const forms: any = [
    <ChangeLevelLicenseForm
      onChangeLevelLicenseCallBackFn={onChangeLevelLicenseStep1CallBackFn}
      licenseFormValues={licenseFormValues}
    />,

    <ChangeLevelLicenseLevel
      stepback={stepback}
      callbackFn={onChangeLevelLicenseStep2CallBackFn}
      currentLicense={currentLicense}
    />,

    <ChangeLevelLicenseSummary
      stepback={stepback}
      callbackFn={onChangeLevelLicenseStep3CallBackFn}
      currentLicense={currentLicense}
      newValuesToChangeLevel={newValuesToChangeLevel}
    />,

    <CopyLicense
      successMessage={
        currentLicense?.master_user_name &&
          currentLicense.master_user_name !== ""
          ? t(
            "licensemanager.changelevel.copy.message_changelevel_two"
          ).replace("[email]", currentLicense?.master_user_name)
          : t("licensemanager.changelevel.copy.message")
      }
      createLicenseResponse={changelevelLicenseResponse}
      onCloseDrawer={onCloseDrawer}
      licenseFormvalues={licenseFormValues}
      title={t("licensemanager.changelevel.copy.title")}
    />,
  ];

  // isDrawerOPen is used multiple times to display UI, basically to refresh DOM and build components in DOM again
  // As Footer section was becoming empty if go from one Drawer to other like Create Drawer, Upgrade Drawer, Change Level Drawer

  return (
    <>
      {" "}
      {isDrawerOpen && (
        <Drawer
          title={t("licensemanager.cards.changelicense.title")}
          placement="right"
          width={1000}
          closable={true}
          onClose={onCloseDrawer}
          open={isDrawerOpen}
          footer={isDrawerOpen && <DrawerFooterArea />}
        >
          <FullWidthSpace direction="vertical">
            <Steps
              items={[
                {
                  title: t("licensemanager.changelevel.steps.checklicense"),
                },

                { title: t("licensemanager.changelevel.steps.changes") },

                { title: t("licensemanager.changelevel.steps.summary") },
                {
                  title: t("licensemanager.changelevel.steps.copylicense"),
                },
              ]}
              current={currentStep}
              labelPlacement="vertical"
              size="small"
            />

            <FullWidthSpace direction="vertical" size="middle">
              {/* <Title level={4}>Define customer & currentLicense details</Title> */}

              <div>
                <Row gutter={[spacings.middle, 0]}>
                  <Col xs={24} md={24}>
                    {isDrawerOpen && forms[currentStep]}
                  </Col>
                </Row>
              </div>
            </FullWidthSpace>
          </FullWidthSpace>
        </Drawer>
      )}
    </>
  );
};
